import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { TabsContext } from '../tabs/tabs-core';
const TabsItemCore = (props) => {
    const { components, className, id, children } = props;
    const { HashTrigger, VisibilityProvider } = components;
    const { currentTab, setCurrentTab } = React.useContext(TabsContext);
    const isCurrent = id === currentTab;
    function BEM() {
        const classArray = ['tabs__item'];
        if (isCurrent) {
            classArray.push('is-current');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    return (React.createElement(VisibilityProvider, { isVisible: isCurrent },
        React.createElement(HashTrigger, { id: id, onMatch: () => setCurrentTab(id), renderWrapper: false },
            React.createElement(CSSTransition, { in: isCurrent, timeout: 300, classNames: "fade" },
                React.createElement("div", { className: BEM(), id: id, tabIndex: 0, role: "tabpanel", "aria-labelledby": `${id}-nav-item` }, isCurrent && children)))));
};
export { TabsItemCore as default, };
